import { createContext, useContext } from 'react';

const RolloutsContext = createContext({ rollouts: {} });

export const RolloutsContextProvider = RolloutsContext.Provider;
export const useRolloutsContext = () => useContext(RolloutsContext);
